export const formatCurrency = (v: number, prefix = "$") =>
  `${prefix}${v.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
